/* HYDR8 checkout guard. Three jobs, all done by watching every way out of the cart from the window, in the capture
   phase, so this runs before any button's own handler. ES5 on purpose.

   1. Minimum order (added 2026-09-28, findability code set). While the cart is under the store minimum, it blocks every
      way into checkout from the cart drawer and the cart page, by mouse, touch or keyboard, including buttons other apps
      put in place of the theme's own (Sami swaps in a copy of Check out that ignores the theme's disabled state). The
      theme renders the current state into [data-hydr8-min-guard] on every cart redraw; minimum-exempt customers render
      "false". Typing /checkout in the address bar is beyond what any theme can stop.

   2. Wholesale route (added 2026-10-07). Sami's wholesale price reaches checkout only when the shopper leaves through
      Sami's copy of the Check out button. That copy disappears whenever the drawer or the cart page is redrawn (the
      drawer opening, a quantity change, the fee line updating), and the theme's own button, which is also what Enter in
      a quantity box presses, then goes to checkout at list price. For a signed-in customer whose tags name a published
      Sami price list, any use of the theme's own button is held: the cart is allowed to settle, Sami is asked to catch
      up, and the checkout continues through Sami's copy. Everyone else goes through the theme's button exactly as
      before, and so does a wholesale customer if Sami is missing or does not catch up in time (fail open: a sale is
      never blocked by this part).

   3. A mark when the wholesale route could not be used (added 2026-10-08). Sami will not fix the vanishing copy on its
      side, and a Sami update can rename what part 2 leans on. Whenever a customer who is on a published price list
      leaves through the theme's own button after all (Sami missing or changed, Sami not caught up in time, the cart
      unreadable), the cart first gets the attribute "H8 route", which shows on the order in the admin under Additional
      details. Staff then know to check that order's prices. Whether the customer is on a price list is asked of the
      theme itself (the section hydr8-wholesale-flag), so the answer does not depend on Sami's script. The mark changes
      nothing for the shopper and never holds a sale for more than a second and a half. */
(function () {
  if (window.__hydr8MinOrderGuard) return;
  window.__hydr8MinOrderGuard = true;
  var CHECKOUT = '[name="checkout"], .cart__checkout-button, .samitaWS-clone-checkout-button, #checkout, #CartDrawer-Checkout';
  var SCOPES = 'cart-drawer, #CartDrawer, #main-cart-footer';
  var SAMI_COPY = 'samitaWS-clone-checkout-button';
  function scopeOf(el) { return (el && el.closest && el.closest(SCOPES)) || document; }
  function belowMinimum(el) {
    var flag = scopeOf(el).querySelector('[data-hydr8-min-guard]') || document.querySelector('[data-hydr8-min-guard]');
    return !!flag && flag.getAttribute('data-below-min') === 'true';
  }
  function checkoutControl(e) {
    var t = e.target;
    return t && t.closest ? t.closest(CHECKOUT) : null;
  }
  function nudge(el) {
    var msg = scopeOf(el).querySelector('.cart__min-order-message');
    if (!msg) return;
    msg.classList.remove('hydr8-min-nudge');
    void msg.offsetWidth;
    msg.classList.add('hydr8-min-nudge');
  }
  function stop(e, el, withNudge) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (withNudge) nudge(el);
  }

  /* ---- 2. wholesale route ---- */
  var WAIT_MS = 8000;      /* how long to wait for the cart and Sami before using the theme's button after all */
  var BUSY_MS = 6000;      /* after handing over, how long the button stays dimmed if Sami has not left the page */
  var HANDED_MS = 15000;   /* after handing over to Sami, how long its own fallback click on the theme's button is let through */
  var state = 0;           /* 0 idle, 1 settling the cart and waiting for Sami (or saving the mark), 2 handed over to Sami */
  var stateAt = 0;
  var bypass = false;      /* true only while this script itself presses the theme's button */
  var PASS_MS = 12000;     /* after falling back to the theme's button, how long every press of it is left alone */
  var passUntil = 0;       /* (the fee app holds that first submit, updates its line, then presses the button again itself) */

  /* ---- 3. the mark ---- */
  var MARK_KEY = 'H8 route';
  var MARK_MS = 1500;      /* the longest a checkout waits for the mark to be saved, or taken off */
  var FLAG_SECTION = 'hydr8-wholesale-flag';
  var onList = null;       /* does the theme say the signed-in customer is on a published price list: true, false, or null while not known */
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function learnOnList() {
    var st = window.__st, page = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    if (!window.fetch) return;
    /* nobody is signed in, by both of Shopify's own records on the page: nothing to ask */
    if (st && !st.cid && page && !page.customerId) { onList = false; return; }
    window.fetch(root() + '?section_id=' + FLAG_SECTION, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = /data-wholesale="(true|false)"/.exec(html || '');
        if (m) onList = (m[1] === 'true');
      })
      ['catch'](function () {});
  }
  function setMark(value, done) {
    var finished = false, timer, attrs = {};
    function go() { if (finished) return; finished = true; window.clearTimeout(timer); done(); }
    timer = window.setTimeout(go, MARK_MS);   /* a sale is never held for the mark */
    attrs[MARK_KEY] = value;
    try {
      window.fetch(root() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
        .then(go)['catch'](go);
    } catch (err) { go(); }
  }

  function sami() {
    var s = window.Samita && window.Samita.Wholesale;
    return (s && typeof s.initialize === 'function' && typeof s.handleCheckout === 'function') ? s : null;
  }
  function isSamiCopy(el) { return !!(el && el.classList && el.classList.contains(SAMI_COPY)); }
  function wholesaleCustomer(s) {
    var c = s.customer, rules = s.wholesalePricing, tags = {}, i, id, ac, t;
    if (!c || !c.id || !rules) return false;
    for (i = 0; c.tags && i < c.tags.length; i++) tags[String(c.tags[i]).toLowerCase()] = true;
    for (id in rules) {
      if (!Object.prototype.hasOwnProperty.call(rules, id)) continue;
      ac = ((rules[id] || {}).customer_configs || {}).apply_customer || {};
      if (ac.type === 'all' || ac.type === 'logged') return true;
      t = ac.tags || [];
      for (i = 0; i < t.length; i++) if (tags[String(t[i]).toLowerCase()]) return true;
    }
    return false;
  }
  function cartKey(cart) {
    var k = [], i;
    if (!cart || !cart.items) return null;
    for (i = 0; i < cart.items.length; i++) k.push(cart.items[i].variant_id + ':' + cart.items[i].quantity);
    return cart.item_count + '|' + k.join(',');
  }
  function readCart(cb) {
    window.fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cb(c); })
      ['catch'](function () { cb(null); });
  }
  function setBusy(on) {
    var el = document.documentElement;
    if (on) el.classList.add('hydr8-checkout-routing'); else el.classList.remove('hydr8-checkout-routing');
  }
  function reset() { state = 0; stateAt = 0; setBusy(false); }
  function inDrawerOf(el) { return !!(el && el.closest && el.closest('cart-drawer, #CartDrawer')); }
  function themeButton(inDrawer) {
    var list = document.querySelectorAll(inDrawer ? 'cart-drawer [name="checkout"], #CartDrawer [name="checkout"]' : '#main-cart-footer [name="checkout"]'), i;
    for (i = 0; i < list.length; i++) if (!isSamiCopy(list[i]) && document.documentElement.contains(list[i])) return list[i];
    return null;
  }
  function samiCopy(inDrawer) {
    var list = document.querySelectorAll(inDrawer ? 'cart-drawer .' + SAMI_COPY + ', #CartDrawer .' + SAMI_COPY : '#main-cart-footer .' + SAMI_COPY), i;
    for (i = 0; i < list.length; i++) if (document.documentElement.contains(list[i]) && !list[i].disabled) return list[i];
    return null;
  }
  function useThemeButton(inDrawer, reason) {
    /* fail open: carry on the way the theme would have, once the mark is on the cart (or MARK_MS has passed) */
    state = 1; stateAt = Date.now(); setBusy(true);
    setMark('store button (' + reason + ') ' + new Date().toISOString(), function () {
      var b = themeButton(inDrawer);
      reset();
      passUntil = Date.now() + PASS_MS;
      if (b && !b.disabled) {
        bypass = true;
        try { b.click(); } finally { bypass = false; }
      } else {
        window.location.href = root() + 'checkout';
      }
    });
  }
  function route(el) {
    var s = sami(), inDrawer = inDrawerOf(el);
    var started = Date.now(), lastKey = null, stableAt = 0, asked = 0, cleared = false;
    state = 1; stateAt = started; setBusy(true);
    function step() {
      if (state !== 1 || stateAt !== started) return;
      if (Date.now() - started > WAIT_MS) { useThemeButton(inDrawer, 'sami timeout'); return; }
      readCart(function (cart) {
        var key = cartKey(cart), copy, now = Date.now();
        if (state !== 1 || stateAt !== started) return;
        if (!key) { useThemeButton(inDrawer, 'cart unreadable'); return; }
        if (key !== lastKey) { lastKey = key; stableAt = now; window.setTimeout(step, 450); return; }
        /* the cart has to hold still (a quantity being saved, the fee line following it) before Sami is asked */
        if (now - started < 900 || now - stableAt < 450) { window.setTimeout(step, 300); return; }
        copy = samiCopy(inDrawer);
        if (copy && cartKey(s.cart) === key) {
          if (!cleared && cart.attributes && cart.attributes[MARK_KEY]) {
            /* an earlier try left the mark and this one is going through Sami: take the mark off, then look again */
            cleared = true;
            setMark('', function () { if (state === 1 && stateAt === started) window.setTimeout(step, 150); });
            return;
          }
          state = 2; stateAt = Date.now();
          window.setTimeout(function () { setBusy(false); }, BUSY_MS);
          window.setTimeout(function () { if (state === 2) reset(); }, HANDED_MS);
          copy.click();
          return;
        }
        if (now - asked > 2500) { asked = now; try { s.initialize(true, ''); } catch (err) {} }
        window.setTimeout(step, 300);
      });
    }
    step();
  }
  /* Returns true when the event was taken over (or swallowed) and nothing else should handle it. */
  function wholesaleRoute(e, el) {
    var s;
    if (bypass || !el || isSamiCopy(el)) {
      /* Sami's copy: leave it to Sami, except while this script is still getting things ready */
      if (!bypass && el && state === 1) { stop(e, el, false); return true; }
      return false;
    }
    if (Date.now() < passUntil) return false;
    if (state === 1) { stop(e, el, false); return true; }
    if (state === 2) {
      if (!e.isTrusted) return false;                               /* Sami's own fallback press */
      if (Date.now() - stateAt < 1500) { stop(e, el, false); return true; }   /* an impatient second click */
    }
    if (!window.fetch) return false;
    s = sami();
    if (!s || !wholesaleCustomer(s)) {
      /* Sami is missing or changed, or does not show this customer on a price list. If the theme says the customer IS
         on one, the theme's button is about to take a price-list customer to checkout without Sami: mark the cart first. */
      if (onList !== true) return false;
      stop(e, el, false);
      useThemeButton(inDrawerOf(el), s ? 'sami no match' : 'sami missing');
      return true;
    }
    stop(e, el, false);
    route(el);
    return true;
  }

  function onPress(e) {
    var t = checkoutControl(e);
    if (t && belowMinimum(t)) stop(e, t, false);
  }
  function onClick(e) {
    var t = checkoutControl(e);
    if (!t) return;
    if (belowMinimum(t)) { stop(e, t, true); return; }
    wholesaleRoute(e, t);
  }
  function onKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = checkoutControl(e);
    if (t && belowMinimum(t)) stop(e, t, true);
  }
  function onSubmit(e) {
    var s = e.submitter;
    if (!s || s.name !== 'checkout') return;
    if (belowMinimum(s)) { stop(e, s, true); return; }
    wholesaleRoute(e, s);
  }
  window.addEventListener('pointerdown', onPress, true);
  window.addEventListener('mousedown', onPress, true);
  window.addEventListener('touchstart', onPress, true);
  window.addEventListener('click', onClick, true);
  window.addEventListener('keydown', onKey, true);
  window.addEventListener('submit', onSubmit, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
  var css = document.createElement('style');
  css.textContent = '@keyframes hydr8MinNudge{0%,100%{transform:none}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}.hydr8-min-nudge{animation:hydr8MinNudge .3s ease 2}' +
    '.hydr8-checkout-routing .cart__checkout-button{opacity:.6;cursor:progress}';
  (document.head || document.documentElement).appendChild(css);
  window.__hydr8Guard = { onList: function () { return onList; } };   /* read-only, for testing */
  learnOnList();
})();
